module.exports = import("/compliance-recording/remoteEntry.js");;